<template>
  <button
    class="spec-button"
    :class="{ selected: selected, inactive: inactive }"
    :title="titleAttr || null"
    @click="select"
  >
    <burger-icon class="burger" v-show="hasSub" />

    <select-box
      v-show="!hasSub"
      :selected="selected"
      @action="select"
    ></select-box>
    <span class="title">{{ title }}</span>
  </button>
</template>

<script>
import BurgerIcon from './BurgerIcon.vue'

export default {
  components: {
    BurgerIcon
  },
  props: {
    selected: {
      type: Boolean
    },
    title: {
      type: String
    },
    inactive: {
      type: Boolean,
      default: false
    },
    // Native hover text, e.g. the reason why the button is inactive
    titleAttr: {
      type: String,
      default: ''
    },
    hasSub: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    select() {
      if (this.inactive) {
        return
      }
      this.$emit('action')
    }
  }
}
</script>

<style lang="scss" scoped>
.spec-button {
  padding: 7px 10px 7px 7px;
  border-radius: 16px;
  font-size: 0.82rem;
  font-weight: 500;
  color: #4f4f4f;
  text-align: left;
  transition: all 0.5s;
  width: 100%;
  display: flex;
  align-items: flex-start;
  line-height: normal;

  &:hover {
    box-shadow: var(--default-shadow);
  }

  &.inactive {
    opacity: 0.35;
    &:hover {
      box-shadow: none;
      cursor: default;
    }
  }

  .select-box {
    margin-top: 0;
    margin-right: 5px;
    flex: 0 0 18px;
  }
}

.burger {
  margin: 4px 6px 0px 2px;
}

span {
  word-break: break-word;
}

.title {
  flex-grow: 1;
}

.selected {
  &.selected {
    background-color: var(--selected-color);
    box-shadow: var(--default-shadow);
  }
}
</style>
